import React from 'react';
import { Link } from 'react-router-dom';

const LegalFooter = () => {
  return (
    <footer className="absolute bottom-0 left-0 right-0 py-3 px-4 bg-transparent">
      <div className="max-w-6xl mx-auto text-center">
        {/* Links Jurídicos - Compacto */}
        <div className="flex flex-wrap justify-center items-center gap-1 mb-1 text-[10px]">
          <Link to="/legal/termos-de-uso" className="text-gray-600 hover:text-[#C79F5E] transition-colors">
            Termos de Uso
          </Link>
          <span className="text-gray-700">•</span>
          <Link to="/legal/privacidade" className="text-gray-600 hover:text-[#C79F5E] transition-colors">
            Política de Privacidade
          </Link>
          <span className="text-gray-700">•</span>
          <Link to="/legal/membro-fundador" className="text-gray-600 hover:text-[#C79F5E] transition-colors">
            Termos Membro Fundador
          </Link>
          <span className="text-gray-700">•</span>
          <Link to="/legal/pagamentos" className="text-gray-600 hover:text-[#C79F5E] transition-colors">
            Política de Pagamentos
          </Link>
          <span className="text-gray-700">•</span>
          <Link to="/legal/conduta" className="text-gray-600 hover:text-[#C79F5E] transition-colors">
            Código de Conduta
          </Link>
        </div>

        {/* Copyright - Compacto */}
        <p className="text-gray-700 text-[9px]">
          © {new Date().getFullYear()} Lyberhot. Todos os direitos reservados. Plataforma tecnológica intermediadora de conteúdo digital.
        </p>
      </div>
    </footer>
  );
};

export default LegalFooter;
